(() => {
  let legacyGuardStarted = false;
  const protectHiddenLegacyFilters = () => {
    if (legacyGuardStarted) return;
    legacyGuardStarted = true;
    let tree;
    let stateObserver;
    let ownsInert = false;
    const bind = () => {
      const next = document.getElementById('gf-tree');
      if (!next || next === tree) return;
      stateObserver?.disconnect();
      if (ownsInert && tree) tree.inert = false;
      tree = next;
      ownsInert = false;
      const sync = () => {
        if (tree.getAttribute('aria-hidden') === 'true') {
          if (!tree.inert) { tree.inert = true; ownsInert = true; }
        } else if (ownsInert) {
          tree.inert = false;
          ownsInert = false;
        }
      };
      stateObserver = new MutationObserver(sync);
      stateObserver.observe(tree, {attributes: true, attributeFilter: ['aria-hidden']});
      sync();
    };
    new MutationObserver(() => { if (!tree?.isConnected) bind(); }).observe(document.body, {childList: true, subtree: true});
    bind();
  };
  const enhance = (root) => {
    if (root.dataset.gEnhanced) return;
    protectHiddenLegacyFilters();
    const forms = Array.from(root.querySelectorAll('[data-g-filter-form],[data-g-sort-form]'));
    const current = new URL(window.location.href);
    const preview = current.searchParams.get('preview_theme_id') || root.dataset.previewThemeId;
    const view = current.searchParams.get('view') || root.dataset.templateView;
    const context = new Map();
    if (preview && /^\d+$/.test(preview)) context.set('preview_theme_id', preview);
    if (view === 'giorgio') context.set('view', view);
    for (const form of forms) {
      for (const [name, value] of context) {
        let input = Array.from(form.querySelectorAll('input[type="hidden"]')).find((item) => item.name === name);
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          form.append(input);
        }
        input.value = value;
      }
      form.addEventListener('submit', () => root.setAttribute('aria-busy', 'true'));
    }
    window.addEventListener('pageshow', () => root.removeAttribute('aria-busy'));
    root.querySelectorAll('[data-g-collection-context]').forEach((link) => {
      const destination = new URL(link.href, window.location.origin);
      if (destination.origin !== window.location.origin) return;
      for (const [name, value] of context) destination.searchParams.set(name, value);
      link.href = destination.href;
    });
    root.querySelectorAll('[data-g-price-range]').forEach((range) => {
      const minimum = range.querySelector('[data-g-price-min]');
      const maximum = range.querySelector('[data-g-price-max]');
      const checkRange = () => {
        const invalid = minimum.value !== '' && maximum.value !== '' && minimum.valueAsNumber > maximum.valueAsNumber;
        maximum.setCustomValidity(invalid ? root.dataset.priceRangeError : '');
      };
      minimum.addEventListener('input', checkRange);
      maximum.addEventListener('input', checkRange);
      checkRange();
    });
    let enhancedPanels = 0;
    root.querySelectorAll('[data-g-panel]').forEach((details) => {
      const trigger = details.querySelector('[data-g-panel-trigger]');
      const dialog = details.querySelector('[data-g-panel-dialog]');
      const closeButton = details.querySelector('[data-g-panel-close]');
      if (!trigger || !dialog || !closeButton || typeof dialog.showModal !== 'function') return;
      dialog.removeAttribute('open');
      details.open = false;
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-expanded', 'false');
      let returnFocus = trigger;
      let previousOverflow = '';
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        if (dialog.open) return;
        returnFocus = document.activeElement instanceof HTMLElement ? document.activeElement : trigger;
        details.open = true;
        previousOverflow = document.documentElement.style.overflow;
        dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        trigger.setAttribute('aria-expanded', 'true');
        closeButton.focus({ preventScroll: true });
      });
      closeButton.addEventListener('click', () => dialog.close());
      dialog.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab') return;
        const focusable = Array.from(dialog.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex="0"]')).filter((element) => element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault(); last?.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault(); first?.focus();
        }
      });
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        details.open = false;
        trigger.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflow = previousOverflow;
        if (returnFocus.isConnected) returnFocus.focus({ preventScroll: true });
      });
      enhancedPanels += 1;
    });
    if (enhancedPanels) root.dataset.gEnhanced = 'true';
  };
  const start = (scope = document) => scope.querySelectorAll('[data-g-collection]').forEach(enhance);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(), { once: true });
  else start();
  document.addEventListener('shopify:section:load', (event) => start(event.target));
})();
